import * as React from 'react'

import { StarIcon, Truck } from 'lucide-react'

import DeliveryActionTypes, {
  getDeliveryActionTypeDisplayName,
} from '~/client/src/desktop/enums/DeliveryActionTypes'
import * as Icons from '~/client/src/shared/components/Icons'
import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

// localization: translated

interface IProps {
  shouldShowActionButtons: boolean
  statusTitle: string
  onNewDeliveryCreate: () => void
  setActionType: (actionType: DeliveryActionTypes) => void
  isAdminMode: boolean
  isCdDeliverySelected: boolean
}

type IAction = {
  actionType: DeliveryActionTypes
  icon: any
  isEnabled: (isAdminMode?: boolean, isCdDeliverySelected?: boolean) => boolean
}

const YES = () => true

const secondaryActions: IAction[] = [
  {
    actionType: DeliveryActionTypes.SUBSCRIBE,
    icon: <StarIcon data-icon="inline-start" />,
    isEnabled: YES,
  },
  {
    actionType: DeliveryActionTypes.ASSIGN,
    icon: <StarIcon fill="currentColor" data-icon="inline-start" />,
    isEnabled: isAdminMode => isAdminMode,
  },
  {
    actionType: DeliveryActionTypes.UPDATE,
    icon: <Icons.DeliveryUpdate data-icon="inline-start" />,
    isEnabled: (_, isCdDeliverySelected) => !isCdDeliverySelected,
  },
  {
    actionType: DeliveryActionTypes.EDIT,
    icon: <Icons.Edit data-icon="inline-start" />,
    isEnabled: (isAdminMode, isCdDeliverySelected) =>
      !isCdDeliverySelected && isAdminMode,
  },
]

export default class DeliveriesListActionBar extends React.PureComponent<IProps> {
  public render() {
    const { statusTitle, onNewDeliveryCreate, shouldShowActionButtons } =
      this.props

    return (
      <div className="row pb10 px24 bb-light-grey">
        <div className="row text large light">
          <div className="pr10 no-grow nowrap">{statusTitle}</div>
          {shouldShowActionButtons && this.renderActionButtons()}
        </div>
        <div className="row x-end no-grow">
          <Button variant="default" onClick={() => onNewDeliveryCreate()}>
            <Truck data-icon="inline-start" />
            {Localization.translator.newDelivery}
          </Button>
        </div>
      </div>
    )
  }

  private renderActionButtons() {
    const { isAdminMode, setActionType, isCdDeliverySelected } = this.props

    return (
      <div className="row bl-light-cool-grey actions-container pl6 pr10">
        {secondaryActions.map(
          ({ actionType, icon, isEnabled }: IAction) =>
            isEnabled(isAdminMode, isCdDeliverySelected) && (
              <Button
                variant="outline"
                className="mx4"
                key={actionType}
                onClick={setActionType.bind(null, actionType)}
              >
                {icon}
                {getDeliveryActionTypeDisplayName(actionType)}
              </Button>
            ),
        )}
      </div>
    )
  }
}
